"use client";

import { c as _c } from "react/compiler-runtime";
import ArrowIcon, { ArrowIconDirection, ArrowIconStyle } from "@/components/common/arrow-icon/arrow-icon";
import Link from "@/components/common/link/link";
import useBreakpoint from "@/hooks/useBreakpoint";
import PaginationNumbers from "./PaginationNumbers";
interface IPaginationProps {
  currentPage: number;
  totalPages: number;
  getPageHref: (page: number) => string;
  className?: string;
}
const Pagination = t0 => {
  const $ = _c(17);
  const {
    currentPage,
    totalPages,
    getPageHref,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const {
    xs
  } = useBreakpoint();
  if (totalPages <= 1) {
    return null;
  }
  const t2 = `flex items-center justify-center gap-1 ${className}`;
  let t3;
  if ($[0] !== currentPage || $[1] !== getPageHref) {
    t3 = currentPage > 1 ? <Link href={getPageHref(currentPage - 1)} rel="prev" className="flex items-center rounded-md px-2 py-2 !font-normal lg:px-4"><ArrowIcon direction={ArrowIconDirection.LEFT} className="ml-0 mr-2 hidden md:block" style={ArrowIconStyle.SECONDARY} />Previous</Link> : <span className="mr-3 flex items-center rounded-md px-2 py-2 opacity-50 lg:px-4"><ArrowIcon direction={ArrowIconDirection.LEFT} className="ml-0 mr-2 hidden md:block" style={ArrowIconStyle.SECONDARY} />Previous</span>;
    $[0] = currentPage;
    $[1] = getPageHref;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = xs ? 1 : 2;
  let t5;
  if ($[3] !== currentPage || $[4] !== getPageHref || $[5] !== t4 || $[6] !== totalPages) {
    t5 = <PaginationNumbers currentPage={currentPage} totalPages={totalPages} getPageHref={getPageHref} delta={t4} />;
    $[3] = currentPage;
    $[4] = getPageHref;
    $[5] = t4;
    $[6] = totalPages;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== currentPage || $[9] !== getPageHref || $[10] !== totalPages) {
    t6 = currentPage < totalPages ? <Link href={getPageHref(currentPage + 1)} rel="next" className="flex items-center rounded-md px-2 py-2 !font-normal lg:px-4">Next<ArrowIcon direction={ArrowIconDirection.RIGHT} className="ml-0 mr-2 hidden md:block" style={ArrowIconStyle.SECONDARY} /></Link> : <span className="ml-3 flex items-center rounded-md px-2 py-2 opacity-50 lg:px-4">Next<ArrowIcon direction={ArrowIconDirection.RIGHT} className="ml-0 mr-2 hidden md:block" style={ArrowIconStyle.SECONDARY} /></span>;
    $[8] = currentPage;
    $[9] = getPageHref;
    $[10] = totalPages;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t2 || $[13] !== t3 || $[14] !== t5 || $[15] !== t6) {
    t7 = <nav className={t2} aria-label="Pagination">{t3}{t5}{t6}</nav>;
    $[12] = t2;
    $[13] = t3;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};
export default Pagination;